import React, { useState } from 'react';
import c from 'classnames';
import { View } from '@uncinc/react-drupal-core';

import {
  WysiwygField,
  Button,
} from '../../../components';

import ViewWithFilters from './ViewWithFilters';

import './style.scss';

const ParagraphBlockReference = ({ entity, className }) => {
  const [blockType, blockId] = entity.getIn(['field_block_reference', 0, 'value']).split('__');
  const [currentPage, setCurrentPage] = useState(0);

  // We only support view blocks for now.
  if (blockType === 'views_block') {
    // eslint-disable-next-line prefer-const
    const [viewId] = blockId.split('_', 1);
    const viewDisplay = blockId.replace(`${viewId}_`, '');

    return (
      <div className={c('Paragraph ParagraphBlockReference', className)}>
        {entity.get('field_title') ? (
          <div className="ParagraphBlockReference__title col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-8">
            <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
          </div>
        ) : null}

        {entity.get('field_text').size > 0 ? (
          <WysiwygField
            property="schema:text"
            className="ParagraphBlockReference__text col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-8 u-margin--bottom--8"
            html={entity.getIn(['field_text', 0, 'processed'])}
          />
        ) : null}

        <div className={c('ParagraphBlockReference__view', {
          'u-margin--top--8': (entity.get('field_title').size > 0 || entity.get('field_text').size > 0),
        })}>
          {viewId === 'vacancies' && viewDisplay === 'overview' ? (
            <ViewWithFilters id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />
          ) : (
            <View id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />
          )}
        </div>


        {entity.get('field_link').size > 0 ? (
          <div className={c('ParagraphBlockReference__link', 'u-multiple-buttons', 'u-multiple-buttons--horizontal', 'u-margin--top--8')}>
            {entity.get('field_link').map((field) => {
              return (
                <Button
                  type="secondary"
                  key={`link:${field.get('title')}`}
                  href={field.get('alias') ? field.get('alias') : field.get('uri')}
                >
                  {field.get('title')}
                </Button>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className={`paragraph--block-reference ${className}`}>
      <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
      <p>Block id: {entity.getIn(['field_block_reference', 0, 'value'])}</p>
    </div>
  );
};

export default ParagraphBlockReference;
